import { render, staticRenderFns } from "./paramStandard.vue?vue&type=template&id=0f44cfad"
import script from "./paramStandard.vue?vue&type=script&lang=js"
export * from "./paramStandard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f44cfad')) {
      api.createRecord('0f44cfad', component.options)
    } else {
      api.reload('0f44cfad', component.options)
    }
    module.hot.accept("./paramStandard.vue?vue&type=template&id=0f44cfad", function () {
      api.rerender('0f44cfad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/processMonitoring/template/paramStandard.vue"
export default component.exports